import { render, staticRenderFns } from "./EditableLabel.vue?vue&type=template&id=62113871&scoped=true&"
import script from "./EditableLabel.vue?vue&type=script&lang=js&"
export * from "./EditableLabel.vue?vue&type=script&lang=js&"
import style0 from "./EditableLabel.vue?vue&type=style&index=0&id=62113871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62113871",
  null
  
)

export default component.exports